import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { route as routePropType } from 'common/propTypes';
import { managePermission } from 'payments/propTypes';
import { ordersRoute } from 'app/containers/routes';
import { selectors as authSelectors } from 'auth';

import OffRampPage from './OffRamp';
import NewOffRampPage from './NewOffRamp';
import OffRampDetailPage from './OffRampDetail';

const Routes = ({ match, offrampPermission, isFetching }) => {
  if (isFetching) return null;

  const canManageOffRamps = offrampPermission === managePermission;

  if (!canManageOffRamps) {
    return <Redirect to={ordersRoute} />;
  }

  return (
    <Switch>
      <Route exact path={`${match.path}/new`} component={NewOffRampPage} />
      <Route exact path={`${match.path}/:id`} component={OffRampDetailPage} />
      <Route exact path={match.path} component={OffRampPage} />
    </Switch>
  );
};

Routes.propTypes = {
  ...routePropType,
  offrampPermission: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const ConnectedRoutes = connect((state) => {
  const { loading: isFetching, offramp: offrampPermission } =
    authSelectors.getPermissions(state);

  return {
    offrampPermission,
    isFetching: !!isFetching,
  };
})(Routes);

export default ConnectedRoutes;
